module.exports = __webpack_public_path__ + "img/愉快.bdeb4f6c.png";